import { render, staticRenderFns } from "./MoleculeEditionBillingAcademyBillingModalBuyers.vue?vue&type=template&id=93cbfb88"
import script from "./MoleculeEditionBillingAcademyBillingModalBuyers.vue?vue&type=script&lang=js"
export * from "./MoleculeEditionBillingAcademyBillingModalBuyers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports